import React, { useEffect, useState } from "react";
import { useCovinDashboard } from "./store";
import moment from "moment";
import DatePicker from "react-datepicker";
import CardDiv from "modules/common/card-div/CardDiv";
import CovinTable from "./CovinTable";
import CloudIcon from "assets/svgs/cloud_icon";
import { Tooltip } from "antd";
import { isDownloadDisabled } from "modules/utilities/utility";
import { Button } from "react-bootstrap";

function CovinDashboard() {
  const { covinData, covinLoading, fetchCovinData, downloadCovinReport } =
    useCovinDashboard();
  const [startDate, setStartDate] = useState(
    moment().subtract(7, "days").toDate()
  );
  const [endDate, setEndDate] = useState(moment().toDate());
  const [page, newPage] = useState(1);

  const getUtcDateRange = (start, end) => ({
    startDateUtc: moment(start).startOf("day").toISOString(),
    endDateUtc: moment(end).endOf("day").toISOString(),
  });

  const loadData = (start, end, page) => {
    const { startDateUtc, endDateUtc } = getUtcDateRange(start, end);
    fetchCovinData(startDateUtc, endDateUtc, page);
  };

  useEffect(() => {
    loadData(startDate, endDate, page);
  }, [page]);

  const handleSubmit = () => {
    loadData(startDate, endDate);
    newPage(1);
  };

  const handleDownload = () => {
    const { startDateUtc, endDateUtc } = getUtcDateRange(startDate, endDate);
    downloadCovinReport(startDateUtc, endDateUtc);
  };

  const handleClear = () => {
    const newStartDate = moment().subtract(7, "days").toDate();
    const newEndDate = moment().toDate();
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    loadData(newStartDate, newEndDate);
    newPage(1);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center">
          <div className="font-poppins">Convin Dashboard</div>
          <div className="d-flex gap-2">
            <DatePicker
              selected={startDate}
              onChange={setStartDate}
              formatWeekDay={(day) => day.slice(0, 3)}
              className="form-control"
              placeholderText="Select previous Date"
              maxDate={endDate}
              minDate={
                endDate
                  ? new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000)
                  : null
              }
            />
            <DatePicker
              selected={endDate}
              onChange={setEndDate}
              formatWeekDay={(day) => day.slice(0, 3)}
              className="form-control"
              placeholderText="Select current Date"
              minDate={startDate}
              maxDate={
                startDate
                  ? new Date(startDate.getTime() + 7 * 24 * 60 * 60 * 1000)
                  : null
              }
            />
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
            <button className="btn btn-primary" onClick={handleClear}>
              Clear
            </button>
            <Tooltip placement="left" title="Download Data">
              <Button
                onClick={handleDownload}
                disabled= {isDownloadDisabled}
              >
                <CloudIcon />
              </Button>
            </Tooltip>
          </div>
        </div>
      }
      component={
        <div>
          <CovinTable
            covinData={covinData}
            covinLoading={covinLoading}
            page={page}
            newPage={newPage}
          />
        </div>
      }
    />
  );
}

export default CovinDashboard;
